import { Typography } from '@mui/material';

const DemoBlock = () => (
  <Typography variant="h2" align="center">
    Exit demo mode to see these features.
  </Typography>
);

export default DemoBlock;
